import React from 'react';
import { useTranslation } from '../../../../../../i18n/use-translation';
import { RegisterRole } from '../../../../../../store/auth/enum/register-role';
import { Select } from '../../../../../molecules/Select/Select';
import * as styles from './ChoosenRole.module.sass';
import { useViewModel } from './hook/use-view-model';
import { ChoosenRoleProps } from './type/props';

export const ChoosenRole = (props: ChoosenRoleProps) => {
  const { t } = useTranslation();
  useViewModel({
    name: props.name,
  });

  return (
    <div className={styles.wrapper}>
      <Select
        name={props.name}
        label={t('role')}
        choices={[
          {
            title: t(RegisterRole.DOCTOR),
            value: RegisterRole.DOCTOR,
          },
          {
            title: t(RegisterRole.FAMILY_DOCTOR),
            value: RegisterRole.FAMILY_DOCTOR,
          },
          {
            title: t(RegisterRole.PATIENT),
            value: RegisterRole.PATIENT,
          },
        ]}
      />
    </div>
  );
};
